import React, { useEffect, useRef, useState } from "react";
import Header from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import backIcon from "../../images/back.png";
import { API_URL } from "../../../config";
import PracticumTable from "./data-table";

import PracticumScoreChart from "./PracticumScoreChart";

function Practicums() {
  const { t } = useTranslation();
  const userId = localStorage.getItem("user_id");
  const client_id = localStorage.getItem("client_id");
  const selectedTrainer = localStorage.getItem("selectedTrainer");
  const [selectedClient, setSelectedClient] = useState(
    localStorage.getItem("selectedClient") == "null"
      ? userId
      : localStorage.getItem("selectedClient")
  );
  const trainerActive = useRef();
  const trainerInactive = useRef();
  const clientActive = useRef();
  const clientInactive = useRef();
  const trainerSelected = useRef();
  const groupSelected = useRef();
  const clientSelected = useRef();
  const selectedtrainerActive = localStorage.getItem("selectedtrainerActive");
  const selectedtrainerInactive = localStorage.getItem(
    "selectedtrainerInactive"
  );
  const selectedclientActive = localStorage.getItem("selectedclientActive");
  const selectedclientInactive = localStorage.getItem("selectedclientInactive");
  const formname = useRef();
  const [trainers, settrainers] = useState([]);
  const [clients, setinclients] = useState([]);
  const [sesstion, setsesstion] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const userType = localStorage.getItem("userType");
  const [loader,setLoader] = useState(false);
  const selectedGroup = localStorage.getItem("selectedGroup");
  const [oepnInterviewHistoryModal, setopenInterviewHistoryModal] =
    useState(false);

  // Dummy data for the table
  const [practicumData, setPracticumData] = useState([
    {
      id: 1,
      pId: "Pr-1",
      objective: "Observing your respiratory physiology.",
    },
    {
      id: 2,
      pId: "Pr-2",
      objective: "Observing your breathing physiology.",
    },
    {
      id: 3,
      pId: "Pr-3",
      objective: "Finding brainstem inhalation reflex",
    },
    {
      id: 4,
      pId: "Pr-4",
      objective: "Exploring your self-intervention techniques",
    },
    {
      id: 5,
      pId: "Pr-5",
      objective: "Managing hypocapnia self-intervention",
    },
    {
      id: 6,
      pId: "Pr-6",
      objective: "Imagination",
    },
    {
      id: 7,
      pId: "Pr-7",
      objective: "In vivo triggers",
    },
    {
      id: 8,
      pId: "Pr-8",
      objective: "Breathing rate challenges",
    },
    {
      id: 9,
      pId: "Pr-9",
      objective: "Desenitization to transition times",
    },
    {
      id: 10,
      pId: "Pr-10",
      objective: "ABA chest vs diaphragm (negative practice)",
    },
    {
      id: 11,
      pId: "Pr-11",
      objective: "Preference training - nose vs mouth",
    },
    {
      id: 12,
      pId: "Pr-12",
      objective: "Guided intensional overbreathing",
    },
    {
      id: 13,
      pId: "Pr-13",
      objective: "PCO2 feedback",
    },
    {
      id: 14,
      pId: "Pr-14",
      objective: "Testing a new habit",
    },
  ]);

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    setInterval(() => {
      setSelectedClient(localStorage.getItem("selectedClient"));
    }, 1000);
  }, []);

  useEffect(() => {
    if (userType == 3 || userType == 4) {
      setinclients([]);
      settrainers([]);
    } else if (userType == 2) {
      getClients();
      settrainers([]);
    } else {
      getTrainers();
      getClients();
    }
  }, []);

  const handleGroup = () => {
    localStorage.setItem("selectedSession", null);
    localStorage.setItem("selectedClient", null);
    if (groupSelected.current.checked) {
      localStorage.setItem("selectedGroup", true);
    } else {
      localStorage.setItem("selectedGroup", false);
    }
    getClients();
  };

  useEffect(() => {
    // if (userId && (userType == 1 || userType == 7)) {
    //     getTrainers();
    // }
    // if (selectedTrainer && (userType == 1 || userType == 2 || userType == 7)) {
    //     getClients();
    // }

    if (selectedClient) {
      getSession();
    }
  }, [selectedClient]);

  const getTrainers = () => {
    let url = API_URL + "/trainers?user_id=" + userId + "&status=2";
    // // console.log(trainerActive);
    let _trainerActive = trainerActive.current.checked;
    let _trainerInactive = trainerInactive.current.checked;

    if (trainerActive.current.checked) {
      localStorage.setItem("selectedtrainerActive", true);
    } else {
      localStorage.setItem("selectedtrainerActive", false);
    }
    if (trainerInactive.current.checked) {
      localStorage.setItem("selectedtrainerInactive", true);
    } else {
      localStorage.setItem("selectedtrainerInactive", false);
    }

    if (_trainerActive && !_trainerInactive) {
      url = API_URL + "/trainers?user_id=" + userId + "&status=1";
    } else if (!_trainerActive && _trainerInactive) {
      url = API_URL + "/trainers?user_id=" + userId + "&status=0";
    } else if (_trainerActive && _trainerInactive) {
      url = API_URL + "/trainers?user_id=" + userId;
    }
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          response.json().then((result) => {
            // console.log(result.trainers)
            if (result.status) {
              settrainers(result.trainers);
              // getClients();
            } else {
              alert("no data error");
            }
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      })
      .catch((err) => {
        // // console.log(err)
      });
  };
  const getClients = () => {
    let _userId = localStorage.getItem("selectedTrainer");
    let _selectedGroup = localStorage.getItem("selectedGroup");
    let _userType = 3;
    let _groupSelected = _selectedGroup === "true" ? true : false;
    let _trainer = true;
    if (_userId == "all") {
      _trainer = false;
    }

    localStorage.setItem("selectedGroup", false);
    if (_groupSelected) {
      localStorage.setItem("selectedGroup", true);
      _userType = 4;
    }

    if (clientActive.current.checked) {
      localStorage.setItem("selectedclientActive", true);
    } else {
      localStorage.setItem("selectedclientActive", false);
    }
    if (clientInactive.current.checked) {
      localStorage.setItem("selectedclientInactive", true);
    } else {
      localStorage.setItem("selectedclientInactive", false);
    }
    let url =
      API_URL +
      "/clients?user_id=" +
      _userId +
      "&status=2&trainer=" +
      _trainer +
      "&user_type=" +
      _userType;
    let _clientActive = clientActive.current.checked;
    let _clientInactive = clientInactive.current.checked;

    if (_clientActive && !_clientInactive) {
      url =
        API_URL +
        "/clients?user_id=" +
        _userId +
        "&status=1&trainer=" +
        _trainer +
        "&user_type=" +
        _userType;
    } else if (!_clientActive && _clientInactive) {
      url =
        API_URL +
        "/clients?user_id=" +
        _userId +
        "&status=0&trainer=" +
        _trainer +
        "&user_type=" +
        _userType;
    } else if (_clientActive && _clientInactive) {
      url =
        API_URL +
        "/clients?user_id=" +
        _userId +
        "&trainer=" +
        _trainer +
        "&user_type=" +
        _userType;
    }

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          response.json().then((result) => {
            // console.log(result.clients)
            if (result.status) {
              setinclients(result.clients);
            } else {
              alert("no data error");
            }
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      })
      .catch((err) => {
        // // console.log(err)
      });
  };

  const getSession = () => {
    let _cid;
    if (localStorage.getItem("selectedClient") == "null") {
      _cid = client_id;
    } else {
      _cid = localStorage.getItem("selectedClient");
    }
    let url = API_URL + "/sessions?cid=" + _cid + "&hw=0";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          response.json().then((result) => {
            if (result.status) {
              setsesstion(result.sessions);
            } else {
              alert("no data error");
            }
          });
        } else if (response.status == 401) {
          logout();
        } else {
          alert("network error");
        }

      })
      .catch((err) => {
        // // console.log(err)

      });
  };

  const updateSelectClient = () => {
 
    localStorage.setItem("selectedClient", clientSelected.current.value);
    getSession();
  };
  const updateSelectTrainer = () => {
    localStorage.setItem("selectedTrainer", trainerSelected.current.value);
    localStorage.setItem("selectedClient", null);

    getClients();
  };

  const getChatsData = () => {
    setLoader(true);

    const url = `${API_URL}/app/get/practicum/score/${selectedClient}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          response.json().then((result) => {
            if (result.status) {
              const updatedPracticumData = practicumData.map((practicum) => {
                const practicumIndex = parseInt(practicum.pId.split("-")[1]);
                const practicumKey = `practicum${practicumIndex}`;

                if (result?.data[practicumKey]) {
                  return {
                    ...practicum,
                    practicum: result?.data[practicumKey], // Attach the relevant practicum array from the API
                  };
                }
                return practicum;
              });
              setPracticumData(updatedPracticumData);
            } else {
              alert("no data error");
            }
    setLoader(false);

          });
        } else if (response.status == 401) {
          logout();
        } else {
          setLoader(false);

          console.log("network error");
        }

      })
      .catch((err) => {
        // // console.log(err)
    setLoader(false);

      });
  };

  console.log("practicumData", practicumData);

  React.useEffect(() => {
    getChatsData();
  }, [selectedClient]);

  return (
    <div>
      <Header />
      <div className="wrp-dashbord">
        <div className="sidebar-section">
          <Sidebar />
        </div>

        <div className="right-section">
          <div className="container-fluid">
            <div className="configer-head">
              <div className="back-icon-wrp">
                <Link to="/view/manageform" className="backbtn-icon">
                  <img src={backIcon} alt="backicon" />
                  <span>{t("Back")}</span>
                </Link>
              </div>
            </div>

            <div className="row">
              {userType == 3 || userType == 4 ? (
                ""
              ) : (
                <>
                  {userType == 2 ? (
                    ""
                  ) : (
                    <div className="col-lg-6">
                      <div className="trainerbox">
                        <div className="trainer-c">
                          <p>{t("trainer")}:</p>
                        </div>
                        <div className="padding-box">
                          <div className="main-checkbox">
                            <div className="checkbox-wrp">
                              <div class="custom-radios">
                                <input
                                  type="checkbox"
                                  id="6"
                                  onChange={getTrainers}
                                  ref={trainerActive}
                                  defaultChecked={
                                    selectedtrainerActive === "true"
                                      ? true
                                      : false
                                  }
                                />
                                <label for="6">
                                  <span className="redious"></span>
                                </label>
                              </div>
                              <div className="caption-cheeckbox">
                                <p>{t("Active")}</p>
                              </div>
                            </div>
                            <div className="checkbox-wrp">
                              <div class="custom-radios">
                                <input
                                  type="checkbox"
                                  id="7"
                                  onChange={getTrainers}
                                  ref={trainerInactive}
                                  defaultChecked={
                                    selectedtrainerInactive === "true"
                                      ? true
                                      : false
                                  }
                                />
                                <label for="7">
                                  <span className="redious"></span>
                                </label>
                              </div>
                              <div className="caption-cheeckbox">
                                <p>{t("Inactive")}</p>
                              </div>
                            </div>
                          </div>
                          <div className="select-client">
                            <select
                              ref={trainerSelected}
                              onChange={updateSelectTrainer}
                              required
                            >
                              <option className="selected-bold">
                                Choose a trainer
                              </option>
                              <option className="selected-bold" value={"all"}>
                                All trainers
                              </option>
                              {trainers.map((items) => (
                                <option
                                  className="selected-bold"
                                  selected={
                                    items.id == selectedTrainer ? true : false
                                  }
                                  value={items.id}
                                >
                                  {items.firstname} {items.lastname}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-6">
                    <div className="trainerbox">
                      <div className="trainer-c">
                        <p>{t("Client")}:</p>
                      </div>
                      <div className="padding-box">
                        <div className="main-checkbox">
                          <div className="checkbox-wrp">
                            <div class="custom-radios">
                              <input
                                type="checkbox"
                                id="color-8"
                                onChange={getClients}
                                ref={clientActive}
                                defaultChecked={
                                  selectedclientActive === "true" ? true : false
                                }
                              />
                              <label for="color-8">
                                <span className="redious"></span>
                              </label>
                            </div>
                            <div className="caption-cheeckbox">
                              <p>{t("Active")}</p>
                            </div>
                          </div>

                          <div className="checkbox-wrp">
                            <div class="custom-radios">
                              <input
                                type="checkbox"
                                id="color-10"
                                onChange={getClients}
                                ref={clientInactive}
                                defaultChecked={
                                  selectedclientInactive === "true"
                                    ? true
                                    : false
                                }
                              />
                              <label for="color-10">
                                <span className="redious"></span>
                              </label>
                            </div>
                            <div className="caption-cheeckbox">
                              <p>{t("Inactive")}</p>
                            </div>
                          </div>
                          {/* <div className="checkbox-wrp">
                            <div class="custom-radios">
                              <input
                                type="checkbox"
                                id="color-12"
                                value="color-12"
                                onChange={handleGroup}
                                ref={groupSelected}
                                defaultChecked={
                                  selectedGroup === "true" ? true : false
                                }
                              />
                              <label for="color-12">
                                <span className="redious"></span>
                              </label>
                            </div>
                            <div className="caption-cheeckbox">
                              <p>{t("Group")}</p>
                            </div>
                          </div> */}
                        </div>
                        <div className="select-client">
                          <select
                            ref={clientSelected}
                            onChange={updateSelectClient}
                          >
                            <option className="selected-bold">
                              Choose a client
                            </option>

                            {clients.length > 0 &&
                              clients.map((client, i) => (
                                <option
                                  className="selected-bold"
                                  selected={
                                    client.id == selectedClient ? true : false
                                  }
                                  value={client.id}
                                >
                                  {client.firstname} {client.lastname}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
              {
                loader ? (
                  <div className="loader">
                      <div className="wrp-chart-loader">
                    <div class="loading">
                        <div class="loading-1"></div>
                        <div class="loading-2"></div>
                        <div class="loading-3"></div>
                        <div class="loading-4"></div>
                    </div>
                </div>
                  </div>
                )
                :
            <div
              style={{
                position: "relative",
              }}
            >
              <PracticumTable
                sesstion={sesstion}
                setsesstion={setsesstion}
                practicumData={practicumData}
                selectedClient={selectedClient}
              />
            </div>
              }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Practicums;
